module.exports = __webpack_public_path__ + "img/kep4-4.e0bf49ea.jpg";